import Icon from './Icon.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'icon', Icon);
  },
};
